module.exports = __webpack_public_path__ + "media/icons/wlasciciel-prywatna-blue@2x-faa7f8ba.png";